import type { PulseError } from '@prenuvo/pulse';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import { ENDPOINTS } from '@/api/endpoints';
import { httpClient } from '@/api/http-client';
import { SessionResponse, UserResponse } from '@/api/model';

const KEY = {
  GET_SESSION: 'GET_SESSION',
  GET_USER: 'GET_USER',
} as const;

const request = {
  getSession: async (signal?: AbortSignal) => {
    const { data } = await httpClient.get<SessionResponse>(ENDPOINTS.AUTH.SESSION, {
      signal,
    });

    return data;
  },
  getUser: async (signal?: AbortSignal) => {
    const { data } = await httpClient.get<UserResponse>(ENDPOINTS.AUTH.USER.CURRENT, { signal });

    return data;
  },
};

const query = {
  useGetSession: (config?: Partial<UseQueryOptions<SessionResponse, PulseError>>) =>
    useQuery<SessionResponse, PulseError>({
      queryFn: ({ signal }) => request.getSession(signal),
      queryKey: [KEY.GET_SESSION],
      // hours * minutes * seconds * milliseconds
      refetchInterval: 2 * 60 * 60 * 1000,
      refetchIntervalInBackground: true,
      refetchOnWindowFocus: 'always',
      ...config,
    }),
  useGetUser: (config?: Partial<UseQueryOptions<UserResponse, PulseError>>) =>
    useQuery<UserResponse, PulseError>({
      queryFn: ({ signal }) => request.getUser(signal),
      queryKey: [KEY.GET_USER],
      ...config,
    }),
};

export const auth = {
  KEY,
  query,
  request,
};
